import { render } from "./EditAnimalSideNav.vue?vue&type=template&id=20ec9a86"
import script from "./EditAnimalSideNav.vue?vue&type=script&lang=js"
export * from "./EditAnimalSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__